import { baseURL } from "../../util/Constant";
import { getMessage } from "../redux/messageSlice";
import { getAllNewSms, loadSms  } from "../redux/smsSlice";
//Get New Sms
export const getNewSmsFetch = () => (dispatch) => {
    dispatch(loadSms(false));
    fetch(`${baseURL}/sms/get`, { method: "GET" })
      .then((res) => res.json())
      .then((data) => {
        if (data.errorCode) {
          dispatch(getMessage(data.message));
          return;
        }
         //console.log(data);
       dispatch(getAllNewSms(data));
      })
      .catch((error) => {
        console.log(error);
      });
  };


  export const postReadSmsFetch = (username, order) => (dispatch) => {
    dispatch(loadSms(false));
   fetch(`${baseURL}/sms/read`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ username, order }),
  })
    .then((res) => res.json())
    .then((data) => {
      // После отметки прочтения, получаем обновленные SMS
      dispatch(getNewSmsFetch());
    })
    .catch((error) => {
      console.log(error);
    });
  };

  export const postReadSmsAdminFetch = () => (dispatch) => {
    dispatch(loadSms(false));
   fetch(`${baseURL}/sms/readAdmin`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    }
  })
    .then((res) => res.json())
    .then((data) => {
      // После отметки прочтения, получаем обновленные SMS
      dispatch(getNewSmsFetch());
    })
    .catch((error) => {
      console.log(error);
    });
  };

